import { Component, Output, Input } from "@angular/core";
import * as _ from "lodash";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";

export interface DocumentRejectionResponse {
  remarks: string;
  name: string;
}

@Component({
  selector: "app-document-rejection-modal",
  templateUrl: "./document-rejection-modal.component.html",
  styleUrls: ["./document-rejection-modal.component.scss"],
})
export class DocumentRejectionModalComponent {
  @Output()
  save: Subject<DocumentRejectionResponse> = new Subject<DocumentRejectionResponse>();

  @Input()
  remarks: string;

  @Input()
  name: string;

  @Input()
  readonly: boolean;

  constructor(private readonly activeModal: NgbActiveModal) {}

  onClose() {
    this.activeModal.dismiss("Cross click");
  }

  get canSave() {
    return !this.readonly && !!this.name && !!this.remarks;
  }

  onSave() {
    this.save.next({ ...this });
    this.activeModal.close();
  }
}
